/* eslint-disable react-hooks/exhaustive-deps */
import {
	ApButtonDanger,
	ApButtonIcon,
	colors,
} from '@alixpartners/ui-components';
import Accordion from 'SpendController/Components/Accordian/Accordian';
import BreakDownFilters from 'SpendController/Components/BreakDownFilters/BreakDownFilters';
import {
	ColumnContainer,
	Container,
	Header,
	HeaderSpan,
	InnerContainer,
	RefreshSpan,
} from 'SpendController/Components/Components.styles';
import LoadingSpinner from 'SpendController/Components/LoadingSpinner/LoadingSpinner';
import EditWorkShopData from 'SpendController/Components/Modal/EditWorkShopData';
import Modal from 'SpendController/Components/Modal/Modal';
import Summary from 'SpendController/Components/Summary/Summary';
import TableView from 'SpendController/Components/TableView';
import { TableWrapper } from 'SpendController/Components/TableView/TableView.style';
import { useSpendControllerFiltersContext } from 'SpendController/Contexts/SpendControllerFiltersProvider';
import {
	BASELINE_KPI_DATA,
	GL_HEADER,
	GL_REFRESH_HEADER,
	PENDING_SAVINGS_SIGNS_OFFS_SUMMARY_TITLE,
	PREWORKSHOP_KPI_DATA,
	SAVINGS_SIGNS_OFF_KPI_DATA,
	convertToPercentage,
	extractSelectedArrays,
	formatPreWorkShopKpiData,
	keyMapping,
	updateSavingsData,
} from 'SpendController/utils';
import React, { useEffect, useState } from 'react';
import {
	deleteSpendControllerData,
	getBaselineSummaryKpis,
	getPreWorkShopSummaryKpis,
	getSavingSignOffSummaryKpis,
	updateWorkshopId,
} from 'utils/apiRequests';
import { spendFormatter } from 'utils/filterNames';

function Baseline(props) {
	const [baselineKpiData, setBaseLineKpiData] = useState(BASELINE_KPI_DATA);
	const [preWorkShopKpiData, setPreWorkShopKpiData] = useState(
		PREWORKSHOP_KPI_DATA
	);
	const [savingsSignoffKpiData, setSavingsSignoffKpiData] = useState(
		SAVINGS_SIGNS_OFF_KPI_DATA
	);
	const [isLoading, setIsLoading] = useState(false);
	const [isTutorialOpen, setIsTutorialOpen] = useState(false);
	const [showSidebar, setShowSideBar] = useState(false);
	const [selectedSpendType, setSelectedSpendType] = useState([
		'MICRO',
		'MACRO',
	]);
	const steps = [
		{
			selector: '[data-tour="baseline-kpi-step-1"]',
			content:
				'This displays the total spend in the dataset and dynamically updates based on the applied filters.',
		},
		{
			selector: '[data-tour="baseline-kpi-step-2"]',
			content:
				'This displays the distinct spend owners in the dataset and dynamically updates based on the applied filters.',
		},
		{
			selector: '[data-tour="baseline-kpi-step-3"] ',
			content:
				'This displays the unique supplier count in the dataset and dynamically updates based on the applied filters.',
		},
		{
			selector: '[data-tour="baseline-kpi-step-4"]',
			content:
				'This displays the unique spend owner and vendor name combination in the dataset and dynamically updates based on the applied filters.',
		},
		// Add more steps as needed
	];
	const {
		filters,
		baselineColumnDefs,
		filterModelData,
		refresh,
		setRefresh,
		setUploadRefresh,
		uploadRefresh,
		workshopState,
		setWorkshopState,
		setSpendType,
	} = useSpendControllerFiltersContext();
	useEffect(
		() => {
			handleKpiData(filters, true);
		},
		[
			filters.stack_1[0].options,
			filters.stack_1[1].options,
			filters,
			filterModelData,
			selectedSpendType,
		]
	);
	useEffect(
		() => {
			refresh && handleKpiData(filters);
		},
		[refresh]
	);
	useEffect(
		() => {
			setSpendType(selectedSpendType);
		},
		[selectedSpendType]
	);

	const handleKpiData = async (filters, realTime = false) => {
		realTime && setIsLoading(true);
		const tempFilters = extractSelectedArrays(filters);
		tempFilters.tailSpendType = selectedSpendType;
		const baselineKpiResponse = await getBaselineSummaryKpis(tempFilters);
		const preWorkshopKpiResponse = await getPreWorkShopSummaryKpis(tempFilters);
		let baselineKpiKeys = Object.keys(baselineKpiResponse.data);
		let newBaselineKpiData = baselineKpiData;
		for (let i = 0; i < baselineKpiKeys.length; i++) {
			newBaselineKpiData.data[i].value = newBaselineKpiData.data[i].isCurrency
				? spendFormatter(baselineKpiResponse.data[baselineKpiKeys[i]])
				: baselineKpiResponse.data[baselineKpiKeys[i]];
		}
		setBaseLineKpiData(newBaselineKpiData);
		let temppreWorkshopKpiData = formatPreWorkShopKpiData(
			preWorkshopKpiResponse.data
		);
		let preWorkshopKpiKeys = Object.keys(temppreWorkshopKpiData);
		let newWorkShopKpiData = preWorkShopKpiData;
		for (let i = 0; i < preWorkshopKpiKeys.length; i++) {
			newWorkShopKpiData.data[i].value = newWorkShopKpiData.data[i].isCurrency
				? spendFormatter(temppreWorkshopKpiData[preWorkshopKpiKeys[i]])
				: newWorkShopKpiData.data[i].isPercent
					? convertToPercentage(temppreWorkshopKpiData[preWorkshopKpiKeys[i]])
					: temppreWorkshopKpiData[preWorkshopKpiKeys[i]];
		}

		setPreWorkShopKpiData(newWorkShopKpiData);
		const savingsSignoffKpiDataResponse = await getSavingSignOffSummaryKpis(
			tempFilters
		);
		const tempPreWorkShopBaselineKpiData = updateSavingsData(
			savingsSignoffKpiDataResponse,
			savingsSignoffKpiData.data,
			keyMapping
		);
		setSavingsSignoffKpiData({
			...savingsSignoffKpiData,
			data: tempPreWorkShopBaselineKpiData,
		});
		realTime && setIsLoading(false);
		setRefresh(false);
	};
	const updateWorkShopData = async (updatedWorkshop, editedData) => {
		await updateWorkshopId(updatedWorkshop);
		setWorkshopState(editedData);
	};
	const handleSpendTypeChange = async value => {
		setSelectedSpendType(value);
	};
	return (
		<Container>
			<LoadingSpinner visible={isLoading} message={`Loading`} />
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				<BreakDownFilters
					location={props.location}
					selectedSpendType={selectedSpendType}
					handleSpendTypeChange={handleSpendTypeChange}
				/>
				<ApButtonIcon
					iconName="baseline_tune"
					iconProps={{ iconColor: colors.grey8 }}
					onClick={() => setShowSideBar(prev => !prev)}
					style={{ marginTop: '9px' }}
				/>
			</div>
			{/* <Filters /> */}
			<InnerContainer>
				<Accordion name={`Baseline Health Bar`} idkey={'acc1'}>
					<Summary
						{...baselineKpiData}
						isTutorialOpen={isTutorialOpen}
						setIsTutorialOpen={setIsTutorialOpen}
						steps={steps}
					/>
				</Accordion>
				<Accordion name={`PreWorkShop Health Bar`} idkey={'acc2'}>
					<Summary {...preWorkShopKpiData} />
				</Accordion>
				<Accordion name={`Savings Sign Off Health Bar`} idkey={'acc3'}>
					<Summary
						{...savingsSignoffKpiData}
						data={[
							savingsSignoffKpiData.data[0],
							savingsSignoffKpiData.data[1],
						]}
					/>
					<Summary
						{...savingsSignoffKpiData}
						data={[
							savingsSignoffKpiData.data[2],
							savingsSignoffKpiData.data[3],
						]}
						title={PENDING_SAVINGS_SIGNS_OFFS_SUMMARY_TITLE}
					/>
				</Accordion>
			</InnerContainer>

			<ColumnContainer>
				<Header>
					<HeaderSpan>{GL_HEADER}</HeaderSpan>
					<RefreshSpan>{GL_REFRESH_HEADER}</RefreshSpan>
				</Header>
				<TableWrapper n={5}>
					<TableView
						data={baselineColumnDefs}
						filters={filterModelData}
						mainfilters={filters}
						handleCall={handleKpiData}
						uploadRefresh={uploadRefresh}
						selectedSpendType={selectedSpendType}
						workshopState={workshopState}
					/>
				</TableWrapper>
			</ColumnContainer>
			{showSidebar && (
				<Modal
					heading="Workshop settings"
					show={showSidebar}
					handleClose={() => setShowSideBar(false)}
				>
					<EditWorkShopData
						onClose={setShowSideBar}
						data={workshopState}
						updateWorkShopData={updateWorkShopData}
					/>
				</Modal>
			)}
			<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
				<ApButtonDanger
					iconName="delete_outline"
					onClick={async () => {
						await deleteSpendControllerData();
						setUploadRefresh(state => !state);
					}}
				>
					Delete all data rows
				</ApButtonDanger>
			</div>
		</Container>
	);
}

export default Baseline;
